import { Component } from 'react';
import { AlertTriangle } from 'lucide-react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
    this.setState({ errorInfo: info });
  }

  componentDidUpdate(prevProps) {
    if (this.props.resetKey !== prevProps.resetKey && this.state.hasError) {
      this.setState({ hasError: false, error: null, errorInfo: null });
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      const isChunkError = this.state.error?.message?.includes('Loading chunk') ||
        this.state.error?.message?.includes('dynamically imported module');

      return (
        <div style={{
          padding: 40, textAlign: 'center',
          fontFamily: 'monospace', color: '#64748b'
        }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16, color: '#f59e0b' }}><AlertTriangle size={32} strokeWidth={1.75} /></div>
          <div style={{ fontSize: 14, marginBottom: 8, color: '#e2e8f0' }}>
            {isChunkError ? 'A new version is available.' : 'Something went wrong loading this page.'}
          </div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 20, maxWidth: 400, margin: '0 auto 20px' }}>
            {isChunkError
              ? 'The application has been updated. Please reload to get the latest version.'
              : 'Please retry the page. If the issue continues, contact support with the current time and client context.'}
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
            <button
              onClick={this.handleRetry}
              style={{
                padding: '8px 16px', background: '#1e2530', border: '1px solid #334155',
                borderRadius: 6, color: '#e2e8f0', cursor: 'pointer', fontSize: 12
              }}
            >
              Try Again
            </button>
            {isChunkError && (
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: '8px 16px', background: '#1e40af', border: '1px solid #2563eb',
                  borderRadius: 6, color: '#fff', cursor: 'pointer', fontSize: 12
                }}
              >
                Reload Page
              </button>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
